<script>
import RawData from "@/components/widgets/raw-data.vue";
export default {
    name: "ApiItems",
    components: {
        RawData
    },
    data() {
        return {
            submitted: false,
            tableData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: "",
            form: {
                id: 0,
                category: "",
            },
            indexSelected: -1,
            tableBusy: false,
            fundSources: [],
            parentID: 0,
            cycles: [],
            cycle: this.$store.state.data.cycle,
            selectedFsId: null,
        };
    },
    computed: {
        filteredData() {
            let data = this.tableData;
            var total = this.currentPage * this.perPage;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        rows(){
            let data = this.tableData;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data.length;
        },
        checkAll: {
            get() {
                var count = 0;
                this.tableData.forEach((item) => {
                    item.toggleSelected && count++;
                });
                return count == this.tableData.length ? true : false;
            },
            set(newValue) {
                if (newValue) {
                    this.tableData.forEach((item) => {
                        item.toggleSelected = true;
                    });
                } else {
                    this.tableData.forEach((item) => {
                        item.toggleSelected = false;
                    });
                }
            },
        },
        selectedRowCheck() {
            var count = 0;
            this.tableData.forEach((item) => {
                item.toggleSelected && count++;
            });
            return count;
        },
    },
    created() {
        var cycles = [{ text: "", value: 0 }];
        this.$store
            .dispatch("cycle/GetAllCycle")
            .then((res) => {
                res.data.forEach((item) => {
                    cycles.push({ value: item.year, text: item.year });
                });
                this.cycles = cycles;
            })
            .catch(() => {
                this.showToast("Something went wrong!","error");
            });
    },
    methods: {
        hideModal() {
            this.$bvModal.hide("import-api-modal");
        },
        getItemFromFS(id, cycle) {
            this.tableData = [];
            this.selectedFsId = id;
            this.cycle = cycle;
            this.tableBusy = true;
            this.$store
                .dispatch("procurable/GetAvailableFSProcurables", {
                    cycle: cycle,
                    campusId: this.$store.state.data.selectedCampus.id,
                    fcId: id,
                })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage,"error");
                    }
                    this.tableBusy = false;
                    res.data.map((item) => {
                        item.ppmpNumberString = item.ppmpNumber;
                        item.filterKey = `${item.apiNumber} ${item.name} ${item.deliveryUnit} ${item.ppmpNumberString}`;
                        item.toggleSelected = false;
                    });
                    this.tableData = res.data;
                })
                .catch((err) => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong!","error");
                });
        },
        importWorks() {
            this.pageLoader(true);
            var data = {
                consolidatedProcurableResourceId: this.parentID,
                apiIds: [],
            };
            this.tableData.forEach((item) => {
                item.toggleSelected && data.apiIds.push(item.id);
            });
            this.$store
                .dispatch("cpritem/CreateCprItem", data)
                .then((res) => {
                    this.pageLoader(false);
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.$emit("dropData", { success: true });
                    this.$bvModal.hide("import-api-modal");
                })
                .catch(() => {
                    this.pageLoader(false);
                    this.showToast("Something went wrong!","error");
                });
        },
        printPPMP(id){
            this.$emit("printPPMP", id);
        },
    },
};
</script>

<template>
    <b-modal
        id="import-api-modal"
        title="API List"
        size="xl"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <div class="row mt-1 mb-2">
            <div class="col-sm-12 col-md-8">
                <div id="tickets-table_filter" class="dataTables_filter">
                    <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                            autocomplete="off"
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm mx-2"
                        ></b-form-input>
                        <b-form-select
                            class="form-select form-select-sm w-25"
                            v-model="perPage"
                            :options="pageOptions"
                        ></b-form-select>
                        Cycle:
                        <b-form-select
                            class="form-select form-select-sm w-50"
                            v-model="cycle"
                            :options="cycles"
                            @change="getItemFromFS(selectedFsId, cycle)"
                        ></b-form-select>
                    </label>
                </div>
            </div>
            <div class="col-sm-12 col-md-4 text-right" v-if="selectedRowCheck > 0">
                <button
                    class="btn btn-primary"
                    type="button"
                    @click="importWorks()"
                >
                    Import ({{ selectedRowCheck }}) selected works
                </button>
            </div>
        </div>
        <div class="table-responsive mb-2">
            <table class="table table-striped mb-0 table-bordered">
                <thead>
                    <tr>
                        <th style="width: 70px">
                            <div
                                class="
                                    form-check
                                    form-checkbox-outline
                                    form-check-success
                                    mb-0
                                "
                            >
                                <input
                                    type="checkbox"
                                    id="customCheckcolor2"
                                    checked="checked"
                                    class="form-check-input"
                                    v-model="checkAll"
                                /><label
                                    for="customCheckcolor2"
                                    class="form-check-label"
                                >
                                    All
                                </label>
                            </div>
                        </th>
                        <th style="width: 120px">
                            PPMP No.
                        </th>
                        <th style="width: 120px">
                            API No.
                        </th>
                        <th style="width: 150px">
                            Delivery Unit
                        </th>
                        <th>Name</th>
                        <th style="width: 150px">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="tableBusy">
                        <td colspan="6" class="text-muted text-center">
                            <div
                                class="
                                    d-flex
                                    justify-content-center
                                    align-items-center
                                "
                            >
                                <div
                                    class="
                                        preloader-component
                                        me-2
                                    "
                                >
                                    <div
                                        class="
                                            status
                                        "
                                    >
                                        <div
                                            class="
                                                spinner-chase
                                                w-20px
                                                h-20px
                                            "
                                        >
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                            <div
                                                class="
                                                    chase-dot
                                                "
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                                <strong
                                    >Loading...</strong
                                >
                            </div>
                        </td>
                    </tr>
                    <tr v-if="filteredData.length == 0 && !tableBusy">
                        <td colspan="6" class="text-muted text-center">
                            <i class="dripicons-warning me-1"></i>No data found
                        </td>
                    </tr>
                    <tr
                        v-for="x in filteredData"
                        :key="x.id"
                        class="cursor-pointer"
                    >
                        <td scope="row" class="position-relative">
                            <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" />
                            <div class="justify-content-center d-flex">
                                <div
                                    class="
                                        form-check
                                        form-checkbox-outline
                                        form-check-success
                                        mb-0
                                    "
                                >
                                    <input
                                        type="checkbox"
                                        :id="`apiID-${x.id}`"
                                        class="form-check-input"
                                        v-model="x.toggleSelected"
                                    />
                                </div>
                            </div>
                        </td>
                        <td>
                            {{ x.ppmpNumberString }}
                            <button type="button" class="btn btn-sm btn-purple" @click="printPPMP(x.id)"><i class="bx bx-printer"></i> Print PPMP</button>
                        </td>
                        <td>
                            {{ x.apiNumber }}
                        </td>
                        <td>
                            {{x.deliveryUnit}}
                        </td>
                        <td>
                            <div @click="x.toggleSelected = !x.toggleSelected">
                                <b class="text-white">{{ x.name }}</b>
                            </div>
                            <div>
                                {{ x.description }}
                            </div>
                        </td>
                        <td>
                            {{
                                Intl.NumberFormat("ja-JP", {
                                    currency: "PHP",
                                    style: "currency",
                                }).format(x.total) 
                            }}
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="row mt-3">
                <div class="col">
                    <div
                        class="
                            dataTables_paginate
                            paging_simple_numbers
                            float-end
                        "
                    >
                        <ul
                            class="
                                pagination pagination-rounded
                                mb-0
                            "
                        >
                            <!-- pagination -->
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="rows"
                                :per-page="perPage"
                            ></b-pagination>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>